
(function(){
  // PROGRESS BAR
  (function(){
    var bar=document.getElementById('fa-progress');
    if(!bar)return;
    window.addEventListener('scroll',function(){
      var p=(window.scrollY/(document.documentElement.scrollHeight-window.innerHeight))*100;
      bar.style.width=p+'%';
    },{passive:true});
  })();

  // CURSOR GLOW
  (function(){
    var glow=document.getElementById('fa-cursor');
    if(!glow)return;
    var raf,tx=0,ty=0,cx=0,cy=0;
    var lerp=function(a,b,t){return a+(b-a)*t};
    document.addEventListener('mousemove',function(e){tx=e.clientX;ty=e.clientY;glow.style.opacity='1'});
    document.addEventListener('mouseleave',function(){glow.style.opacity='0'});
    (function tick(){cx=lerp(cx,tx,.08);cy=lerp(cy,ty,.08);glow.style.left=cx+'px';glow.style.top=cy+'px';requestAnimationFrame(tick)})();
  })();

  // SCROLL REVEAL
  (function(){
    var obs=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting)e.target.classList.add('visible')});
    },{threshold:.1});
    document.querySelectorAll('.fa-reveal').forEach(function(el){obs.observe(el)});
  })();

  // TILT 3D ON CARDS
  document.querySelectorAll('.fa-tilt').forEach(function(el){
    el.addEventListener('mousemove',function(e){
      var r=el.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
      el.style.transform='perspective(800px) rotateX('+(-(y-.5)*6)+'deg) rotateY('+((x-.5)*6)+'deg)';
      el.style.setProperty('--mx',x*100+'%');
      el.style.setProperty('--my',y*100+'%');
    });
    el.addEventListener('mouseleave',function(){
      el.style.transform='perspective(800px) rotateX(0) rotateY(0)';
    });
    el.addEventListener('click',function(){
      var url=el.dataset.url;if(url)window.location.href=url;
    });
  });

  // CURSOR GLOW ON CS CARDS
  document.querySelectorAll('.fa-cs-card').forEach(function(el){
    el.addEventListener('mousemove',function(e){
      var r=el.getBoundingClientRect();
      el.style.setProperty('--mx',((e.clientX-r.left)/r.width*100)+'%');
      el.style.setProperty('--my',((e.clientY-r.top)/r.height*100)+'%');
    });
  });

  // ─── COLLECTION PAGE ────────────────────────────────────────────────
  // VIEW TOGGLE (bento / grid / list)
  var viewBtns=document.querySelectorAll('.fa-view-btn');
  var grid=document.getElementById('fa-products-grid');
  if(grid && viewBtns.length){
    viewBtns.forEach(function(btn){
      btn.addEventListener('click',function(){
        viewBtns.forEach(function(b){b.classList.remove('active')});
        btn.classList.add('active');
        var view=btn.dataset.view;
        grid.className='';
        if(view==='bento') grid.className='fa-bento-a';
        else if(view==='grid') grid.className='fa-grid-b';
        else grid.className='fa-list-c';
      });
    });
  }

  // FILTER CHIPS (client-side by data-category)
  var filterChips=document.querySelectorAll('.fa-filter-chip');
  var productCards=document.querySelectorAll('.fa-product-card-wrap');
  if(filterChips.length && productCards.length){
    filterChips.forEach(function(chip){
      chip.addEventListener('click',function(){
        filterChips.forEach(function(c){c.classList.remove('active')});
        chip.classList.add('active');
        var cat=chip.dataset.filter;
        productCards.forEach(function(wrap){
          if(cat==='tout' || wrap.dataset.category===cat){
            wrap.removeAttribute('data-hidden');
            wrap.style.display='';
          } else {
            wrap.dataset.hidden='true';
            wrap.style.display='none';
          }
        });
        // update count
        var countEl=document.querySelector('.fa-results-count');
        if(countEl){
          var visible=[].filter.call(productCards,function(w){return w.style.display!=='none'}).length;
          countEl.textContent=visible+' produits';
        }
      });
    });
  }

  // SORT (redirect with sort_by param)
  var sortSel=document.getElementById('fa-sort');
  if(sortSel){
    sortSel.addEventListener('change',function(){
      var url=new URL(window.location.href);
      url.searchParams.set('sort_by',sortSel.value);
      window.location.href=url.toString();
    });
  }

  // ─── PRODUCT PAGE ────────────────────────────────────────────────
  // GALLERY THUMBS
  var thumbs=document.querySelectorAll('.fa-thumb');
  var galleryImgs=document.querySelectorAll('.fa-gallery-img');
  if(thumbs.length && galleryImgs.length){
    thumbs.forEach(function(thumb){
      thumb.addEventListener('click',function(){
        var idx=parseInt(thumb.dataset.index)||0;
        thumbs.forEach(function(t){t.classList.remove('active')});
        galleryImgs.forEach(function(img){img.classList.remove('active')});
        thumb.classList.add('active');
        if(galleryImgs[idx]) galleryImgs[idx].classList.add('active');
      });
    });
  }

  // PRODUCT TABS
  var tabBtns=document.querySelectorAll('.fa-tab-btn');
  var tabPanels=document.querySelectorAll('.fa-tab-panel');
  if(tabBtns.length){
    tabBtns.forEach(function(btn){
      btn.addEventListener('click',function(){
        tabBtns.forEach(function(b){b.classList.remove('active')});
        tabPanels.forEach(function(p){p.classList.remove('active')});
        btn.classList.add('active');
        var target=document.getElementById('fa-tab-'+btn.dataset.tab);
        if(target) target.classList.add('active');
      });
    });
  }

  // SIZE SELECTOR
  var sizeBtns=document.querySelectorAll('.fa-size-btn');
  var variantInput=document.getElementById('fa-variant-id');
  var productJSON=document.getElementById('fa-product-json');
  var productData=null;
  if(productJSON){try{productData=JSON.parse(productJSON.textContent)}catch(e){}}
  var selectedOptions={};
  sizeBtns.forEach(function(btn){
    btn.addEventListener('click',function(){
      var optionPos=btn.dataset.option;
      document.querySelectorAll('.fa-size-btn[data-option="'+optionPos+'"]').forEach(function(b){b.classList.remove('active')});
      btn.classList.add('active');
      selectedOptions[optionPos]=btn.dataset.value;
      updateVariant();
    });
  });

  // COLOR SELECTOR
  var colorDots=document.querySelectorAll('.fa-color-dot');
  colorDots.forEach(function(dot){
    dot.addEventListener('click',function(){
      var optionPos=dot.dataset.option;
      document.querySelectorAll('.fa-color-dot[data-option="'+optionPos+'"]').forEach(function(d){d.classList.remove('active')});
      dot.classList.add('active');
      selectedOptions[optionPos]=dot.dataset.value;
      var labelEl=document.getElementById('fa-color-label');
      if(labelEl) labelEl.textContent=dot.dataset.label;
      updateVariant();
    });
  });

  function updateVariant(){
    if(!productData||!variantInput)return;
    var variant=productData.variants.find(function(v){
      return Object.keys(selectedOptions).every(function(pos){
        return v['option'+pos]===selectedOptions[pos];
      });
    });
    if(variant){
      variantInput.value=variant.id;
      var addBtn=document.querySelector('.fa-btn-add');
      if(addBtn){
        if(variant.available){
          addBtn.textContent='Ajouter au panier — '+formatMoney(variant.price);
          addBtn.disabled=false;
        } else {
          addBtn.textContent='Épuisé';
          addBtn.disabled=true;
        }
      }
    }
  }

  function formatMoney(cents){
    return (cents/100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,' ')+'€';
  }

  // STICKY BAR
  var stickyBar=document.getElementById('fa-sticky-bar');
  var stickyCta=document.getElementById('fa-sticky-cta');
  if(stickyBar){
    window.addEventListener('scroll',function(){
      if(window.scrollY>500) stickyBar.classList.add('visible');
      else stickyBar.classList.remove('visible');
    },{passive:true});
  }
  if(stickyCta){
    stickyCta.addEventListener('click',function(){
      var addBtn=document.querySelector('.fa-btn-add');
      if(addBtn) addBtn.click();
    });
  }

})();
